/** Kelp LRTWithdrawalManager — per-user enumeration + delay blocks.
 *  Proxy address on chain 1: `0x62De59c08eB5dAE4b7E6F7a8cAd3006d6965ec16`
 *  (verified unchanged post-March-2026 restart). Implementation:
 *  `0x0eCDe3F414d1A245246d121e37191D9a63684e19`.
 *
 *  `userAssociatedNonces` (storage slot 156) is an OZ
 *  `DoubleEndedQueue.Uint256Deque` keyed by `(asset, user)`. The
 *  length is read off-chain via `eth_getStorageAt`; per-element
 *  detail comes from `getUserWithdrawalRequest`. */
export const KelpWithdrawalManagerAbi = [
  {
    name: 'getUserWithdrawalRequest',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'asset' },
      { type: 'address', name: 'user' },
      { type: 'uint256', name: 'userIndex' },
    ],
    outputs: [
      { type: 'uint256', name: 'rsETHAmount' },
      { type: 'uint256', name: 'expectedAssetAmount' },
      { type: 'uint256', name: 'withdrawalStartBlock' },
      { type: 'uint256', name: 'userNonce' },
    ],
  },
  {
    name: 'withdrawalDelayBlocks',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
